import { createIcon } from '../createIcon';
import { ReactComponent as IconWarehouseAlt } from '../svg/warehouse-alt.svg';

export default createIcon(IconWarehouseAlt);
